import {Component, Inject, OnInit} from '@angular/core';
import {FormGroup, UntypedFormBuilder, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {OriginsService} from "@core/services/backend/common/service/origins.service";
import {Origin} from "@core/services/backend/common/interface/origins";

@Component({
    selector: 'vex-origins-create-update',
    templateUrl: './origins-create-update.component.html',
    styleUrls: ['./origins-create-update.component.scss']
})
export class OriginsCreateUpdateComponent implements OnInit {

    form: FormGroup;
    mode: 'create' | 'update' = 'create';

    constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
                private dialogRef: MatDialogRef<OriginsCreateUpdateComponent>,
                private fb: UntypedFormBuilder,
                private translateService: TranslateService,
                private snackbar: MatSnackBar,
                private origins: OriginsService) {
    }

    ngOnInit() {
        // Normalizar el objeto defaults para manejar variantes del backend (id/ID)
        if (this.defaults) {
            // Normalizar el ID (manejar tanto 'id' como 'ID')
            if (this.defaults.ID !== undefined && this.defaults.id === undefined) {
                this.defaults.id = this.defaults.ID;
            }
            if (this.defaults.id !== undefined || this.defaults.ID !== undefined) {
                this.mode = 'update';
            } else {
                this.mode = 'create';
            }
        } else {
            this.mode = 'create';
            this.defaults = {} as Origin;
        }

        // Obtener el ID normalizado
        const originId = this.defaults?.id !== undefined ? this.defaults.id : (this.defaults?.ID !== undefined ? this.defaults.ID : null);
        
        console.log('Origins Create/Update - defaults:', this.defaults);
        console.log('Origins Create/Update - originId:', originId);
        console.log('Origins Create/Update - mode:', this.mode);

        this.form = this.fb.group({
            id: [originId || null],
            name: [this.defaults.name || '', [Validators.required]],
            active: [this.defaults.active !== false]
        });
    }

    save() {
        if (this.mode === 'create') {
            this.create();
        } else if (this.mode === 'update') {
            this.update();
        }
    }

    create() {
        const origin = this.form.value;
        delete origin.id;
        this.origins.create(origin).subscribe({
            next: (result) => {
                this.snackbar.open('Origen creado correctamente', '', {
                    duration: 3000
                });
                this.dialogRef.close(result);
            },
            error: (err) => {
                this.snackbar.open('Error al crear el origen', '', {
                    duration: 3000
                });
            }
        });
    }

    update() {
        if (!this.form.valid) {
            this.snackbar.open('Por favor complete todos los campos requeridos', '', {
                duration: 3000
            });
            return;
        }

        // Obtener el ID de múltiples fuentes posibles
        const formId = this.form.get('id')?.value;
        const defaultsId = this.defaults?.id;
        const defaultsID = this.defaults?.ID;
        const originId = formId || defaultsId || defaultsID;
        
        console.log('Update origin - formId:', formId);
        console.log('Update origin - defaultsId:', defaultsId);
        console.log('Update origin - defaultsID:', defaultsID);
        console.log('Update origin - final originId:', originId);
        
        // Validar que el ID esté presente antes de enviar
        if (!originId || originId === null || originId === undefined) {
            console.error('Error: ID de origen no encontrado. Form value:', this.form.value, 'Defaults:', this.defaults);
            this.snackbar.open('Error: ID de origen no encontrado. No se puede actualizar.', '', {
                duration: 3000
            });
            return;
        }

        // Construir el payload asegurando que el ID esté presente y sea un número
        const origin = {
            id: Number(originId), // Asegurar que sea un número
            name: this.form.value.name,
            active: this.form.value.active !== false
        };
        
        console.log('Updating origin with payload:', origin);

        this.origins.update(origin).subscribe({
            next: (result) => {
                this.snackbar.open('Origen actualizado correctamente', '', {
                    duration: 3000
                });
                this.dialogRef.close(result);
            },
            error: (err) => {
                console.error('Error updating origin:', err);
                console.error('Payload sent:', origin);
                this.snackbar.open('Error al actualizar el origen', '', {
                    duration: 3000
                });
            }
        });
    }

    cancel() {
        this.dialogRef.close();
    }
}

